import { connect } from 'react-redux';
import { actions } from 'reducers';
import authStatus from 'constants/auth-status';

const mapStateToProps = state => ({
  isLoggedOut: state.auth.status === authStatus.ANONYMOUS
});

const mapDispatchToProps = {
  logout: actions.auth.logout
};

export default connect(mapStateToProps, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/components/logout/enhance.js